export default __webpack_public_path__ + "static/media/42.cd1ed8fe.png";